module.exports = __webpack_public_path__ + "static/img/图片1.55662bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/图片1.png
// module id = JuqH
// module chunks = 29